/**
 * Maps control panel identifiers (lowercase) to their standardized display names.
 * Ensures correct casing (e.g., "InterWorx" with capital W, "cPanel" with lowercase c).
 */
const controlPanelDisplayNames: Record<string, string> = {
	interworx: 'InterWorx',
	cpanel: 'cPanel',
	plesk: 'Plesk',
};

/**
 * Returns the standardized display name for a given control panel.
 * Matches case-insensitively and returns the proper casing.
 * If no mapping exists, returns null to omit the field entirely.
 */
export const getControlPanelDisplayName = (
	controlPanel: string | null | undefined,
): string | null => {
	if (!controlPanel) {
		return null;
	}

	const lowerCase = controlPanel.toLowerCase();

	// Check if the control panel string contains any known control panel names
	for (const [key, displayName] of Object.entries(controlPanelDisplayNames)) {
		if (lowerCase.includes(key)) {
			return displayName;
		}
	}

	return null;
};

export default controlPanelDisplayNames;
